import React from 'react';

const SvgRightArrowIcon = (props) => (
  <svg
    viewBox="0 0 22 22"
    width="1em"
    height="1em"
    {...props}
    id="RightArrowIcon">
    <path d="M15 18v-4.8H0V8.8h15V4l7 7-7 7z" fill="currentColor" />
  </svg>
);

export default SvgRightArrowIcon;
